import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContinueLearningCard = ({ course, enrollment, nextLesson }) => {
  const progressPercentage = enrollment?.progressPercent || 0;
  const continueUrl = `/video-learning-interface?orgId=${enrollment?.orgId}&courseId=${enrollment?.courseId}${
    nextLesson?.id ? `&lessonId=${nextLesson?.id}` : ''
  }`;

  return (
    <div className="bg-white/30 backdrop-blur-xl rounded-xl p-4 sm:p-6 border border-white/40 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Play" size={20} className="text-accent" />
        <h3 className="text-base sm:text-lg font-semibold text-foreground">Continue Learning</h3>
      </div>
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="relative w-full sm:w-40 md:w-48 h-32 sm:h-28 rounded-lg overflow-hidden bg-muted flex-shrink-0 flex items-center justify-center">
          {course?.thumbnailUrl ? (
            <img src={course?.thumbnailUrl} alt={course?.title} className="w-full h-full object-cover" />
          ) : (
            <Icon name="BookOpen" size={28} className="text-muted-foreground" />
          )}
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="font-medium text-foreground mb-1 line-clamp-2">{course?.title}</h4>
          {nextLesson && (
            <p className="text-sm text-muted-foreground mb-3 line-clamp-1">
              Next up: <span className="text-foreground">{nextLesson?.title || 'Untitled Lesson'}</span>
            </p>
          )}

          <div className="mb-4">
            <div className="flex justify-between text-sm text-muted-foreground mb-1">
              <span>Progress</span>
              <span>{Math.round(progressPercentage)}% complete</span>
            </div>
            <div className="w-full bg-white/40 rounded-full h-2">
              <div
                className="bg-accent h-2 rounded-full transition-all duration-500"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
          </div>

          <Link to={continueUrl}>
            <Button variant="default" fullWidth iconName="Play" iconPosition="left">
              Continue
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContinueLearningCard;